/* VIRELA · comportamiento del tema: cabecera, menú, apariciones, vista previa, barra de compra y carrito. */
(function () {
  "use strict";
  var doc = document;

  /* ---------- Cabecera: línea inferior al bajar ---------- */
  var header = doc.querySelector("[data-v-header]");
  if (header) {
    var alBajar = function () { header.classList.toggle("is-scrolled", window.scrollY > 8); };
    alBajar();
    window.addEventListener("scroll", alBajar, { passive: true });
  }

  /* ---------- Menú móvil ---------- */
  var menu = doc.querySelector("[data-v-menu]");
  var abrir = doc.querySelector("[data-v-menu-abrir]");
  var cerrar = doc.querySelector("[data-v-menu-cerrar]");
  if (menu && abrir && cerrar) {
    var poner = function (abierto) {
      menu.classList.toggle("is-open", abierto);
      menu.setAttribute("aria-hidden", abierto ? "false" : "true");
      abrir.setAttribute("aria-expanded", abierto ? "true" : "false");
      doc.documentElement.style.overflow = abierto ? "hidden" : "";
      (abierto ? cerrar : abrir).focus();
    };
    abrir.addEventListener("click", function () { poner(true); });
    cerrar.addEventListener("click", function () { poner(false); });
    doc.addEventListener("keydown", function (e) { if (e.key === "Escape" && menu.classList.contains("is-open")) poner(false); });
    menu.addEventListener("click", function (e) { if (e.target.closest("a")) poner(false); });
  }

  /* ---------- Aparición al hacer scroll ---------- */
  var revelables = doc.querySelectorAll("[data-v-reveal]");
  if (revelables.length) {
    if (!("IntersectionObserver" in window)) {
      revelables.forEach(function (el) { el.classList.add("is-in"); });
    } else {
      var obs = new IntersectionObserver(function (entradas) {
        entradas.forEach(function (en) {
          if (en.isIntersecting) { en.target.classList.add("is-in"); obs.unobserve(en.target); }
        });
      }, { rootMargin: "0px 0px -8% 0px", threshold: 0.08 });
      revelables.forEach(function (el) { obs.observe(el); });
    }
  }

  /* ---------- Vista previa de páginas: flechas ---------- */
  doc.querySelectorAll("[data-v-prev]").forEach(function (bloque) {
    var pista = bloque.querySelector("[data-v-pista]");
    if (!pista) return;
    var mover = function (sentido) {
      var paso = pista.querySelector("figure");
      pista.scrollBy({ left: sentido * ((paso ? paso.offsetWidth : 300) + 24) * 2, behavior: "smooth" });
    };
    var atras = bloque.querySelector("[data-v-atras]");
    var adelante = bloque.querySelector("[data-v-adelante]");
    if (atras) atras.addEventListener("click", function () { mover(-1); });
    if (adelante) adelante.addEventListener("click", function () { mover(1); });
  });

  /* ---------- Barra de compra fija en la ficha ---------- */
  var barra = doc.querySelector("[data-v-barra]");
  var compra = doc.querySelector("#comprar");
  if (barra && compra && "IntersectionObserver" in window) {
    new IntersectionObserver(function (entradas) {
      var en = entradas[0];
      barra.classList.toggle("is-on", !en.isIntersecting && en.boundingClientRect.top < 0);
    }).observe(compra);
  }

  /* ---------- Carrito: casilla de desistimiento ---------- */
  var formCarrito = doc.querySelector("[data-v-cart-form]");
  if (formCarrito) {
    formCarrito.addEventListener("submit", function (e) {
      var casilla = formCarrito.querySelector("[data-v-consent]");
      var aviso = formCarrito.querySelector("[data-v-consent-error]");
      if (casilla && !casilla.checked) {
        e.preventDefault();
        if (aviso) aviso.hidden = false;
        casilla.focus();
      }
    });
  }

  /* ---------- Función de desistimiento: prepara el email ---------- */
  var formDes = doc.querySelector("[data-v-desistimiento]");
  if (formDes) {
    formDes.addEventListener("submit", function (e) {
      e.preventDefault();
      var dato = function (n) { return (formDes.querySelector('[name="' + n + '"]') || {}).value || ""; };
      var cuerpo = [
        "Comunico que desisto del contrato de compra siguiente:",
        "",
        "Número de pedido: " + dato("pedido"),
        "Fecha del pedido: " + dato("fecha"),
        "Nombre: " + dato("nombre"),
        "Email de la compra: " + dato("email"),
        "",
        "Fecha de esta comunicación: " + new Date().toLocaleDateString("es-ES"),
      ].join("\n");
      window.location.href = "mailto:" + formDes.getAttribute("data-email") + "?subject=" + encodeURIComponent("Desistimiento del pedido " + dato("pedido")) + "&body=" + encodeURIComponent(cuerpo);
      var ok = formDes.querySelector("[data-v-desistimiento-ok]");
      if (ok) ok.hidden = false;
    });
  }
})();
